import { render, staticRenderFns } from "./IconActivate.vue?vue&type=template&id=a65b2dbe"
import script from "./IconActivate.vue?vue&type=script&lang=js"
export * from "./IconActivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports